module.exports = __webpack_public_path__ + "img/0_5.db90d858.png";